import { render, staticRenderFns } from "./chinaMap.vue?vue&type=template&id=7b365cd4&scoped=true"
import script from "./chinaMap.vue?vue&type=script&lang=js"
export * from "./chinaMap.vue?vue&type=script&lang=js"
import style0 from "./chinaMap.vue?vue&type=style&index=0&id=7b365cd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b365cd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b365cd4')) {
      api.createRecord('7b365cd4', component.options)
    } else {
      api.reload('7b365cd4', component.options)
    }
    module.hot.accept("./chinaMap.vue?vue&type=template&id=7b365cd4&scoped=true", function () {
      api.rerender('7b365cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/chinaMap.vue"
export default component.exports